import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.462 2.493a6.5 6.5 0 0 1 8.99 6.007 6.5 6.5 0 0 1-1.905 4.597l-8.84 8.84a1 1 0 0 1-1.414 0l-8.84-8.84a6.501 6.501 0 0 1 9.192-9.196l.002.002.353.35.353-.35.002-.002a6.5 6.5 0 0 1 2.107-1.408m2.488 1.505a4.5 4.5 0 0 0-3.183 1.319l-.003.003-1.06 1.05a1 1 0 0 1-1.408 0l-1.063-1.053a4.501 4.501 0 0 0-6.366 6.366L12 19.816l8.133-8.133a4.501 4.501 0 0 0-3.183-7.685",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }